// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__2QriW","content":"Modal_content__11ZmY"};